import React from 'react'
import { makeStyles } from '@mui/styles'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { Grid, IconButton } from '@mui/material'
import { Warehouse } from '../../../interfaces/Warehouse/Warehouse'
import { ListElementText } from '../../UI/ListElementText'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import VisibilityIcon from '@mui/icons-material/Visibility'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  content: {
    flex: 'auto'
  },
  cover: {
    width: 151
  }
}))
interface WarehouseElementProps {
  element: Warehouse
  handleEdit: (param: Warehouse) => void
  handleDelete: (param: number | undefined) => void
  handleView: (idView: number) => void
}

export const WarehouseElement: React.FC<WarehouseElementProps> = ({
  element,
  handleEdit,
  handleDelete,
  handleView
}) => {
  const classes = useStyles()

  return (
    <Card className={classes.root}>
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Grid container direction='row' spacing={2}>
            <Grid item xs={12} sm={6} lg={2}>
              <ListElementText title='CODIGO' text={element.warehouseCode} />
            </Grid>
            <Grid item xs={12} sm={6} lg={2}>
              <ListElementText title='NOMBRE' text={element.warehouseName} />
            </Grid>
            <Grid item xs={12} sm={6} lg={2}>
              <ListElementText title='CP' text={element.postalCode} />
            </Grid>
            <Grid item xs={12} sm={6} lg={2}>
              <ListElementText
                title='DIRECCIÓN ALMACÉN'
                text={element.warehouseAddress}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={2}>
              <ListElementText
                title='ACTIVO'
                text={element.active ? 'SI' : 'NO'}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={2}>
              <IconButton
                aria-label='delete'
                onClick={() => handleDelete(element.id)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton aria-label='edit' onClick={() => handleEdit(element)}>
                <EditIcon />
              </IconButton>
              <IconButton
                aria-label='view'
                onClick={() => handleView(element.id)}
              >
                <VisibilityIcon />
              </IconButton>
            </Grid>
          </Grid>
        </CardContent>
      </div>
    </Card>
  )
}
